import {Controller, useFormContext} from "react-hook-form";
import {NotAnActiveClientInput, WasClientAssignedToProviderMap} from "../../domain";
import {SimpleDropdown} from "common";
import React from "react";

type WasClientAssignedToProviderInputProps = {
    sending: boolean;
};

export function WasClientAssignedToProviderInput({sending}: WasClientAssignedToProviderInputProps) {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<NotAnActiveClientInput>();

    return (
        <div className="w-full text-black-200 pb-2 text-base items-center">
            <div className="flex items-center">
                <div className="w-2/6 text-right">
                    Was Client Assigned to Provider
                </div>
                <div className="w-1/6 ml-4 items-center">
                    <Controller
                        name="wasClientAssignedToProvider"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={WasClientAssignedToProviderMap}
                                selected={value}
                                disabled={sending}
                                hasErrorBorder={errors.wasClientAssignedToProvider !== undefined}
                                setSelected={(selected) => {
                                    setValue("wasClientAssignedToProvider", selected);
                                    clearErrors("wasClientAssignedToProvider");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>

            {
                errors.wasClientAssignedToProvider &&
                <div className="pt-2 flex w-full">
                    <div className="w-2/6">
                    </div>
                    <div className="w-4/6 ml-6 text-red-700">
                        Please select “Was Client Assigned to Provider” before submitting
                    </div>
                </div>
            }
        </div>
    );
}
